export interface OverrideFieldValues {
  sourceRoot: string;
  targetLocation: string;
  targetFilename: string;
}

export interface OverrideValidationErrors {
  sourceRoot?: string;
  targetLocation?: string;
  targetFilename?: string;
}

const MAX_FIELD_LENGTH = 255;

export function validateOverrideFields(values: OverrideFieldValues): OverrideValidationErrors {
  const errors: OverrideValidationErrors = {};

  for (const field of ['sourceRoot', 'targetLocation', 'targetFilename'] as const) {
    if (values[field].length > MAX_FIELD_LENGTH) {
      errors[field] = `Must not exceed ${MAX_FIELD_LENGTH} characters`;
    }
  }

  return errors;
}
